import * as React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import getAbValueAction from 'actions/abExperimentsActions';
import styles from './ProductAvailabilityMessage.css';
export const ProductAvailabilityMessage = (props) => {
    const { showMessage, intent, message, className, getAbValue } = props;
    if (!showMessage || !intent)
        return null;
    const isIntentPositive = intent.match(/positive/i);
    const enableBillionFSN = getAbValue('enableBillionFSN', false);
    if (message && message.toLowerCase() === 'pre order' && enableBillionFSN) {
        return null;
    }
    return (<div className={cx(styles['message-box'], className)} data-aid={`product_availability_${message}`}>
			<span className={cx({
        [styles['message-box--positive']]: !!isIntentPositive,
        [styles['message-box--negative']]: !isIntentPositive
    })}>
				{message}
			</span>
		</div>);
};
const mapDispatchToProps = {
    getAbValue: getAbValueAction
};
export default connect(null, mapDispatchToProps)(ProductAvailabilityMessage);
